import React, { createContext, useContext, useState, useEffect } from 'react'
import { statelessJSON } from 'Export/ExportJson'
import { regValues, row_content } from 'Export/ExportC'
import { setSettings } from 'Import/ImportJson'

import { TYPE } from 'configuration';

let read = true;
let lread = false;
const SettingsContext = createContext()
const LoadedContext = createContext()
const SetLoadedContext = createContext()

const state_object = (state) => {
	return { value : state[0], setValue : state[1] }
}

const SettingsState = () => {
	return {
		'usb' : {
			'charging source' : state_object(useState(5)),
			'force hrv_low hi-z' : state_object(useState(false)),
			'force bat_low hi-z' : state_object(useState(false)),
			'always disable usb ldo': state_object(useState(false))
		},
		'vsup' : {
			'behaviour when disabled' : state_object(useState(1)),
			'force enable' : state_object(useState(false)),
			'initial state' : state_object(useState(0)),
			'sleep' : state_object(useState(1000)),
		},
		'vaux': {
			'0' : {
				'enable' : state_object(useState(false)),
				'disable in hrv_low mode': state_object(useState(false)),
				'constantly connect to' : state_object(useState(0))
			},
			'1' : {
				'enable' : state_object(useState(false)),
				'disable in hrv_low mode': state_object(useState(false)),
				'constantly connect to' : state_object(useState(0))
			},
			'2' : {
				'enable' : state_object(useState(false)),
				'disable in hrv_low mode': state_object(useState(false)),
				'constantly connect to' : state_object(useState(0))
			}
		},
		'vaux gnd' : {
			'0': {
				'enable' : state_object(useState(false)),
				'open in hrv_low mode' : state_object(useState(false)),
				'connection' : state_object(useState(0))
			},
			'2': {
				'enable' : state_object(useState(false)),
				'open in hrv_low mode' : state_object(useState(false)),
				'connection' : state_object(useState(0))
			},
			'1': {
				'enable' : state_object(useState(false)),
				'open in hrv_low mode' : state_object(useState(false)),
				'connection' : state_object(useState(0))
			}
		},
		'wakeup' : {
			'de-bouncer' : state_object(useState(true)),
			'i2c_address' : state_object(useState(0x77)),
			'3 wire interface' : state_object(useState(false)),
			'edge' : state_object(useState(1)),
			'sda' : state_object(useState(0))
		},
		'supervisory' : {
			'battery protector' : state_object(useState(true)),
			'always connect' : state_object(useState(false))
		},
		'timing' : {
			'mode' : state_object(useState('default')),
			't_hrv_period' : state_object(useState(8192)),
			't_hrv_meas' : state_object(useState(128)),
			't_sts_period' : state_object(useState(8)),
			't_lts_period' : state_object(useState(1024)),
			't_hrv_low_period' : state_object(useState(256)),
			't_lts_hrv_low_period' : state_object(useState(32768)),
		},
		'harvester power supervisory' : {
			'harvesting element' : state_object(useState('solar')),
			'mppt ratio' : state_object(useState(6)),
			'minimum open voltage' : state_object(useState(100)),
			'Imax' : state_object(useState(1)),
			'v_hrv_min' : state_object(useState(0.146)),
			'hrv_check_lvl' : state_object(useState(2)),
			'pin max' : state_object(useState(20))
		},
		'capacitors' : {
			'c_hrv' : { 'value' : state_object(useState(4.7)), 'unit' : state_object(useState(2)) },
			'c_reg' : { 'value' : state_object(useState(470)), 'unit' : state_object(useState(2)) },
			'sts' : {
				'type' : state_object(useState('capacitor')),
				'capacitance' : state_object(useState(47)),
				'capacity' : state_object(useState(10)),
				'self-discharge-current' : state_object(useState(0)),
				'input-resistance' : state_object(useState(0)),
				'output-resistance' : state_object(useState(0)),
			},
			'lts' : {
				'type' : state_object(useState('capacitor')),
				'capacitance' : state_object(useState(47)),
				'capacity' : state_object(useState(10)),
				'self-discharge-current' : state_object(useState(0)),
				'input-resistance' : state_object(useState(0)),
				'output-resistance' : state_object(useState(0)),
			},
		},
		'supervisory level' : {
			'v_lvl_acc' : state_object(useState("TYP")),
			'lts initial voltage' : state_object(useState(0)),
			'v_bat_max_hi' : state_object(useState(41)),
			'v_bat_max_lo' : state_object(useState(40)),
			'apl_enabled' : state_object(useState(true)),
			'v_apl_max_hi' : state_object(useState(37)),
			'v_apl_max_lo' : state_object(useState(33)),
			'v_bat_min_hi_dis' : state_object(useState(30)),
			'v_bat_min_hi_con' : state_object(useState(30)),
			'v_bat_min_lo' : state_object(useState(29)),
		},
		'ldo levels' : {
			'v_ulp_ldo' : state_object(useState(1.55)),
			'v_ulp_ldo_acc' : state_object(useState("TYP")),
			'v_aux_ldo' : state_object(useState(1.55)),
			'v_aux_ldo_acc' : state_object(useState("TYP")),
		},
		'cold-start accuracy' : {
			'v_cs_acc' : state_object(useState("TYP"))
		},
		'overwrite' : {
			'reg_t_hrv_period' : state_object(useState('')),
			'reg_t_hrv_meas' : state_object(useState('')),
			'reg_t_sts_period' : state_object(useState('')),
			'reg_t_lts_period' : state_object(useState('')),
			'reg_v_hrv_cfg' : state_object(useState('')),
			'reg_hrv_check_lvl' : state_object(useState('')),
			'reg_lts_cfg' : state_object(useState('')),
			'reg_v_bat_max_hi' : state_object(useState('')),
			'reg_v_bat_max_lo' : state_object(useState('')),
			'reg_v_bat_min_hi_dis' : state_object(useState('')),
			'reg_v_bat_min_hi_con' : state_object(useState('')),
			'reg_v_bat_min_lo' : state_object(useState('')),
			'reg_v_apl_max_hi' : state_object(useState('')),
			'reg_v_apl_max_lo' : state_object(useState('')),
			'reg_ldo_cfg' : state_object(useState('')),
			'reg_pwr_cfg' : state_object(useState('')),
			'reg_vaux_cfg' : state_object(useState('')),
			'reg_vaux_gnd_cfg' : state_object(useState('')),
			'reg_mppt_ratio' : state_object(useState('')),
			'reg_ext_cfg' : state_object(useState('')),
			'reg_t_sleep_vsup_lo' : state_object(useState('')),
			'reg_t_sleep_vsup_mid' : state_object(useState('')),
			'reg_t_sleep_vsup_hi' : state_object(useState('')),
			'reg_t_hrv_low_cfg' : state_object(useState('')),
			'reg_spi_i2c_cfg' : state_object(useState('')),
			'reg_pwr_mgt' : state_object(useState('')),
		}
	}
}

const Settings = ({children}) => {
	const settings = SettingsState()
	const [loaded, setLoaded] = useState({});

	useEffect(() => {
		if (read) {
			const data = localStorage.getItem(`autosave-${TYPE}`)
			if (data) {
				try {
					const json = JSON.parse(data)
					setSettings(json, settings)
				} catch (e) {
					console.error(e)
				}
			}
			read = false
		} else {
			const s = {...settings}
			localStorage.setItem(`autosave-${TYPE}`, JSON.stringify(statelessJSON(s)))
		}
		// eslint-disable-next-line
	}, [settings])

	useEffect(() => {
		if (!lread) {
			const data = localStorage.getItem(`loaded-${TYPE}`)
			if (data) {
				try {
					const json = JSON.parse(data)
					setLoaded(json)
					lread = true;
				} catch (e) {
					console.error(e)
				}
			} else {
				regValues(settings, row_content);
				localStorage.setItem(`loaded-${TYPE}`, JSON.stringify(row_content));
				setLoaded({});
			}
		} else {
			lread = false;
		}
		// eslint-disable-next-line
	}, [loaded])

	return (
		<SettingsContext.Provider value={settings}>
			<LoadedContext.Provider value={loaded}>
				<SetLoadedContext.Provider value={setLoaded}>
				{children}
				</SetLoadedContext.Provider>
			</LoadedContext.Provider>
		</SettingsContext.Provider>
	)
}

const useLoaded = () => {
	return [useContext(LoadedContext), useContext(SetLoadedContext)]
}

const useSettings = () => {
	return [useContext(SettingsContext)]
}

const resetSettings = (settings, loaded) => {
	const usb = settings['usb']
	const vsup = settings['vsup']
	const vaux = settings['vaux']
	const vaux_gnd = settings['vaux gnd']
	const wakeup = settings['wakeup']
	const supervisory = settings['supervisory']
	const timing = settings['timing']
	const hps = settings['harvester power supervisory']
	const capacitors = settings['capacitors']
	const supervisory_level = settings['supervisory level']
	const ldo_levels = settings['ldo levels']
	const csa = settings['cold-start accuracy']
	const overwrite = settings['overwrite'];

	usb['charging source'].setValue(5)
	usb['force hrv_low hi-z'].setValue(false)
	usb['force bat_low hi-z'].setValue(false)
	usb['always disable usb ldo'].setValue(false)
	
	vsup['behaviour when disabled'].setValue(1)
	vsup['force enable'].setValue(false)
	vsup['initial state'].setValue(0)
	vsup['sleep'].setValue(1000)

	const resetVaux = (i) => {
		const cvaux = vaux[i];
		cvaux['enable'].setValue(false)
		cvaux['disable in hrv_low mode'].setValue(false)
		cvaux['constantly connect to'].setValue(0)
	}

	for (let i = 0; i < 3; ++i) {
		resetVaux(i)
	}

	const resetVauxGnd = (i) => {
		const cgnd = vaux_gnd[i]
		cgnd['enable'].setValue(false)
		cgnd['open in hrv_low mode'].setValue(false)
		cgnd['connection'].setValue(0)
	}

	for (let i = 0; i < 3; ++i) {
		resetVauxGnd(i)
	}

	wakeup['de-bouncer'].setValue(true)
	wakeup['i2c_address'].setValue(0x77)
	wakeup['3 wire interface'].setValue(false)
	wakeup['edge'].setValue(1)
	wakeup['sda'].setValue(0)

	supervisory['battery protector'].setValue(true)
	supervisory['always connect'].setValue(false)

	timing['mode'].setValue('default')
	timing['t_hrv_period'].setValue(8192)
	timing['t_hrv_meas'].setValue(128)
	timing['t_sts_period'].setValue(8)
	timing['t_lts_period'].setValue(1024)
	timing['t_hrv_low_period'].setValue(256)
	timing['t_lts_hrv_low_period'].setValue(32768)

	hps['harvesting element'].setValue('solar')
	hps['minimum open voltage'].setValue(100)
	hps['Imax'].setValue(1)
	hps['v_hrv_min'].setValue(0.146)
	hps['hrv_check_lvl'].setValue(2)
	hps['pin max'].setValue(20)

	capacitors['c_hrv']['value'].setValue(4.7)
	capacitors['c_hrv']['unit'].setValue(2)

	capacitors['c_reg']['value'].setValue(470)
	capacitors['c_reg']['unit'].setValue(2)

	capacitors['sts']['type'].setValue('capacitor');
	capacitors['sts']['capacitance'].setValue(47);
	capacitors['sts']['capacity'].setValue(10);
	capacitors['sts']['self-discharge-current'].setValue(0);
	capacitors['sts']['input-resistance'].setValue(0);
	capacitors['sts']['output-resistance'].setValue(0);

	capacitors['lts']['type'].setValue('capacitor');
	capacitors['lts']['capacitance'].setValue(47);
	capacitors['lts']['capacity'].setValue(10);
	capacitors['lts']['self-discharge-current'].setValue(0);
	capacitors['lts']['input-resistance'].setValue(0);
	capacitors['lts']['output-resistance'].setValue(0);

	supervisory_level['v_lvl_acc'].setValue("TYP")
	supervisory_level['lts initial voltage'].setValue(0)
	supervisory_level['v_bat_max_hi'].setValue(41)
	supervisory_level['v_bat_max_lo'].setValue(40)
	supervisory_level['apl_enabled'].setValue(true)
	supervisory_level['v_apl_max_hi'].setValue(37)
	supervisory_level['v_apl_max_lo'].setValue(33)
	supervisory_level['v_bat_min_hi_dis'].setValue(30)
	supervisory_level['v_bat_min_hi_con'].setValue(30)
	supervisory_level['v_bat_min_lo'].setValue(29)

	ldo_levels['v_ulp_ldo'].setValue(1.55)
	ldo_levels['v_ulp_ldo_acc'].setValue("TYP")
	ldo_levels['v_aux_ldo'].setValue(1.55)
	ldo_levels['v_aux_ldo_acc'].setValue("TYP")

	csa['v_cs_acc'].setValue("TYP")

	overwrite['reg_t_hrv_period'].setValue('')
	overwrite['reg_t_hrv_meas'].setValue('')
	overwrite['reg_t_sts_period'].setValue('')
	overwrite['reg_t_lts_period'].setValue('')
	overwrite['reg_v_hrv_cfg'].setValue('')
	overwrite['reg_hrv_check_lvl'].setValue('')
	overwrite['reg_lts_cfg'].setValue('')
	overwrite['reg_v_bat_max_hi'].setValue('')
	overwrite['reg_v_bat_max_lo'].setValue('')
	overwrite['reg_v_bat_min_hi_dis'].setValue('')
	overwrite['reg_v_bat_min_hi_con'].setValue('')
	overwrite['reg_v_bat_min_lo'].setValue('')
	overwrite['reg_v_apl_max_hi'].setValue('')
	overwrite['reg_v_apl_max_lo'].setValue('')
	overwrite['reg_ldo_cfg'].setValue('')
	overwrite['reg_pwr_cfg'].setValue('')
	overwrite['reg_vaux_cfg'].setValue('')
	overwrite['reg_vaux_gnd_cfg'].setValue('')
	overwrite['reg_mppt_ratio'].setValue('')
	overwrite['reg_ext_cfg'].setValue('')
	overwrite['reg_t_sleep_vsup_lo'].setValue('')
	overwrite['reg_t_sleep_vsup_mid'].setValue('')
	overwrite['reg_t_sleep_vsup_hi'].setValue('')
	overwrite['reg_t_hrv_low_cfg'].setValue('')
	overwrite['reg_spi_i2c_cfg'].setValue('')
	overwrite['reg_pwr_mgt'].setValue('')

	localStorage.removeItem('loaded-8500');
	loaded = {};
}

export { Settings, useSettings, resetSettings, useLoaded }
